/**
 * @generated SignedSource<<b217e7aa9c4bfda2c54a61ded2cf021a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResetUserPasswordInput = {
  key: number;
};
export type ResetUserPasswordMutation$variables = {
  input: ResetUserPasswordInput;
};
export type ResetUserPasswordMutation$data = {
  readonly resetUserPassword: {
    readonly user: {
      readonly key: number;
    };
  } | null | undefined;
};
export type ResetUserPasswordMutation = {
  response: ResetUserPasswordMutation$data;
  variables: ResetUserPasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetUserPasswordMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "resetUserPassword",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ResetUserPasswordMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "resetUserPassword",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3962d9274adb0119f9adb5dcb9cd574",
    "id": null,
    "metadata": {},
    "name": "ResetUserPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ResetUserPasswordMutation(\n  $input: ResetUserPasswordInput!\n) {\n  resetUserPassword(input: $input) {\n    user {\n      key\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "80f9bd91a9761ad150f81d80b8429b12";

export default node;
